import { useAppDispatch, useAppSelector } from '../../../store/store';
import { setHideUnmergeable, setMergeMode, toggleMergeSelection } from '../../../store/sessionSlice';

/**
 * Merge mode on the session history page and the sessions picked for a merge. Both live in the
 * store, so they are still there after a visit to the compare page.
 */
const useSessionMergeSelection = () => {
  const dispatch = useAppDispatch();
  const { isMergeMode, selectedIds, hideUnmergeable } = useAppSelector((state) => state.session.mergeSelection);

  return {
    isMergeMode,
    selectedIds,
    hideUnmergeable,
    setMergeMode: (value: boolean) => dispatch(setMergeMode(value)),
    setHideUnmergeable: (value: boolean) => dispatch(setHideUnmergeable(value)),
    toggleSelection: (sessionId: string) => dispatch(toggleMergeSelection(sessionId)),
  };
};

export default useSessionMergeSelection;
